import API from "../Services/API";
import Model from "./Model";

const useStats = (alwaysRefresh = false) => {
    return Model({
        stateKey: 'stats',
        alwaysRefresh: alwaysRefresh,
        fetchData: () => API.get(`/app/stats`),
        returnDataKey: 'stats',
        defaultLoadingError: 'Sorry, there was an error loading stats.',
    })
}

export {
    useStats,
};
